import { render, staticRenderFns } from "./DropdownCompare.vue?vue&type=template&id=421a53d8&scoped=true&"
import script from "./DropdownCompare.vue?vue&type=script&lang=ts&"
export * from "./DropdownCompare.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownCompare.vue?vue&type=style&index=0&id=421a53d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421a53d8",
  null
  
)

export default component.exports